import React, { useEffect, useState } from 'react'
import axios from 'axios';
import queryString from 'query-string';
import TopTitle from './TopTitle';
import { Container, Row, Col } from 'react-bootstrap';
import { comma,instance } from './common';


function totalPrice(data) {
    let price = 0;
    data.forEach(function (v) {
        price += Number(v.s_member_price);
    });
    return comma(price);
}

function sendPrice(data) {
    let price = 0;
    data.forEach(function (v) {
        price += Number(v.s_member_price);
    });
    return price;
}

function totalCount(data) {

    return Number(data.length - 1);
}



// function SigongId({si_id,si_data,setSiData}){




//     let obj = {si_id:si_id}
//     useEffect(() => {

//         const fetchData = async () => {
//             axios.post('https://abys-service.co.kr:3001/sigong/id',obj).then(function(res){

//                 setSiData(res.data[0]);        
//             });

//         };

//         fetchData();

//     }, []);


//     const {si_name,si_address} = si_data;

//     return (
//         <>
//             <h3 className="font-weight-bold mb-3" id="si_name">{si_name}</h3>
//             <span id="si_address">{si_address}</span>
//         </>
//     )
// }


function ServiceId({ data, u_type, date, location }) {
    const query = queryString.parse(location.search);
    let r_id = query.r_id;

    let str = '';
    let s_cate = '';
    if (data.s_id) {
        str = JSON.parse(data.s_id);
        s_cate = str[0].s_cate;
    }
    
    console.log('ServiceId data : ', str)
    
    //데이터 조회
    const loadobj ={
        r_id:r_id
    }



    const [before, setBefore] = useState([]);
    const [after, setAfter] = useState([]);
    useEffect(() => {

        const fetchData = async () => {
            instance.post('/rep_car/work_id',loadobj).then(function (res) {
                console.log('로드 데이터 확인', res.data[0])
                
                let u_car_name = res.data[0].u_car_name;
                let car_name = document.getElementById('car_name');
                car_name.append(u_car_name);


                setBefore(JSON.parse(res.data[0].photo_before));
                setAfter(JSON.parse(res.data[0].photo_after));
                

                
                
                

            });

        };

        fetchData();

    }, []);
    
    
    const circleImg = {        
        backgroundColor: '#c4c4c4',
        width: '10px',
        height: '10px',
        borderRadius: '50%'
    }
    const g_circleImg = {        
        backgroundColor: '#2F79D9',
        width: '10px',
        height: '10px',
        borderRadius: '50%'
    }

    const longLine = {
        height: '70px',
        width: '1px',
        backgroundColor: '#c4c4c4',
        marginLeft: '4px'
    }
    const g_longLine = {
        height: '70px',
        width: '1px',
        backgroundColor: '#2F79D9',
        marginLeft: '4px'
    }
    
    const longLine2 = {
        height: '130px',
        width: '1px',
        backgroundColor: '#c4c4c4',
        marginLeft: '4px'
    }
    const g_longLine2 = {
        height: '130px',
        width: '1px',
        backgroundColor: '#2F79D9',
        marginLeft: '4px'
    }
    
    return (
        <>
            {
                str &&
                str.map(v => <div className="row p-0 mt-2 mb-5" key={v.s_id}>
                    <div className="col-4 p-0" id="s_img">
                        <div className="r_r_bg" style={{ backgroundImage: 'url(' + v.s_img + ')' }}></div>
                    </div>
                    <div className="col-8 pr-0">
                        <div className="font-weight-bold r_title mb-2" id="s_name">{v.s_name}</div>
                        <div className="mb-2 btn btn-outline-secondary" id="s_name" style={{marginTop: '52px'}}>{data.r_status}</div>
                        
                    </div>
                </div>)
            }
            <div className="r_b_border mb-4">
                <h3 className="font-weight-bold mb-3">예약정보</h3>
            </div>
            <div className="r_mb_down p-0">
                <div className="mb-3 position-relative">
                    <span className="font-weight-bold r_s_size">차량</span>
                    <span className="" id="car_name" style={{position: 'absolute', right: '0'}}></span>
                </div>
                <div className="position-relative">
                    <span className="font-weight-bold r_s_size">예약일</span>
                    <span className="" id="reserveDate" style={{position: 'absolute', right: '0'}}>{data.r_reserve_date}</span>
                </div>
                {/* <div className="col-9">
                    <div id="si_date" className="text-right">{date}</div>
                </div> */}
            </div>
            <div className="row r_b_border mb-4 p-0">
                <h3 className="font-weight-bold mb-3">진행상태</h3>
            </div>

            {/* <span className="d-block" style={{color:'#999'}}>{data.r_ipgo} 입고 완료</span> */}

                <div className="d-flex border-0 p-0 pt-3" style={{marginBottom: '100px'}}>
                    <div className="col-1 pl-0" style={{marginTop:'9px'}}>
                        {
                            data.r_status == "입고완료"
                            ?
                            <>
                            <div className="circleImg" style={g_circleImg}></div>
                            <div className="grayLongLine" style={longLine}></div>
                            <div className="circleImg" style={circleImg}></div>
                            <div className="grayLongLine2" style={longLine2}></div>
                            <div className="circleImg" style={circleImg}></div>
                            </>
                            :data.r_status == "검수완료"
                            ?
                            <>
                            <div className="circleImg" style={g_circleImg}></div>
                            <div className="grayLongLine" style={g_longLine}></div>
                            <div className="circleImg" style={g_circleImg}></div>
                            <div className="grayLongLine2" style={longLine2}></div>
                            <div className="circleImg" style={circleImg}></div>
                            </>
                            :data.r_status == "작업완료"
                            ?
                            <>
                            <div className="circleImg" style={g_circleImg}></div>
                            <div className="grayLongLine" style={g_longLine}></div>
                            <div className="circleImg" style={g_circleImg}></div>
                            <div className="grayLongLine2" style={g_longLine2}></div>
                            <div className="circleImg" style={g_circleImg}></div>
                            </>
                            :
                            <>
                            <div className="circleImg" style={circleImg}></div>
                            <div className="grayLongLine" style={longLine}></div>
                            <div className="circleImg" style={circleImg}></div>
                            <div className="grayLongLine2" style={longLine2}></div>
                            <div className="circleImg" style={circleImg}></div>
                            </>
                        }
                        
                    </div>
                    <div className="col-11 pr-0">
                        <div id="topWrapBox" style={{height: '80px'}}>
                            {
                                data.r_status == '입고완료'
                                ?
                                <>
                                <span className="font-weight-bold d-block" style={{fontSize:'18px'}}>차량입고완료</span>
                                <span className="d-block" style={{color:'#999'}}>{data.r_ipgo} 입고 완료</span>
                                </>
                                : data.r_status == '검수완료'
                                ?
                                <>
                                <span className="font-weight-bold d-block" style={{fontSize:'18px'}}>차량입고완료</span>
                                <span className="d-block" style={{color:'#999'}}>{data.r_ipgo} 입고 완료</span>
                                </>
                                : data.r_status == '작업완료'
                                ?
                                <>
                                <span className="font-weight-bold d-block" style={{fontSize:'18px'}}>차량입고완료</span>
                                <span className="d-block" style={{color:'#999'}}>{data.r_ipgo} 입고 완료</span>
                                </>
                                :
                                <>
                                <span className="font-weight-bold d-block" style={{fontSize:'18px'}}>차량입고</span>
                                </>
                                

                            } 
                        </div>
                        <div style={{height: '140px'}}>
                            {
                                data.r_status == '검수완료'
                                ?
                                <>                                
                                <span className="font-weight-bold d-block" style={{fontSize:'18px'}}>검수완료</span>
                                <span className="d-block" style={{color:'#999'}}>{data.r_gumsu} 검수 완료</span>
                                <div className="div-overflow-wrap">
                                <div className="p_wrapMid ml-4 mt-3">
                                    {
                                        before.length !=0
                                        ?
                                        before.map(v => <div className="p_midimg mr-4" style={{background:'url(\''+v+'\')'}}></div>)
                                        :<div></div>
                                    }        
                                </div>
                            </div>
                                </>
                                :data.r_status == '작업완료'
                                ?
                                <>                                
                                <span className="font-weight-bold d-block" style={{fontSize:'18px'}}>검수완료</span>
                                <span className="d-block" style={{color:'#999'}}>{data.r_gumsu} 검수 완료</span>
                                <div className="div-overflow-wrap">
                                <div className="p_wrapMid ml-4 mt-3">
                                    {
                                        before.length !=0
                                        ?
                                        before.map(v => <div className="p_midimg mr-4" style={{background:'url(\''+v+'\')'}}></div>)
                                        :<div></div>
                                    }        
                                </div>
                            </div>
                                </>
                                :
                                <>
                                <span className="font-weight-bold d-block" style={{fontSize:'18px'}}>검수</span>
                                </>
                            }
                        </div>
                        <div>
                            {
                                data.r_status == '작업완료'
                                ?
                                <>
                                <span className="font-weight-bold d-block" style={{fontSize:'18px'}}>작업완료</span>
                                <span className="d-block" style={{color:'#999'}}>{data.r_enddate} 작업 완료</span>
                                
                                </>
                                :
                                <>
                                <span className="font-weight-bold d-block" style={{fontSize:'18px'}}>작업</span>
                                </>
                            }
                        </div>
                        
                        
                    </div>
                </div>


                        

                

 
            
        </>

    )
}

function WorkDetailPage({ history, location }) {
    const session = JSON.parse(window.sessionStorage.result);
    const { u_type, u_id } = session;

    const query = queryString.parse(location.search);
    let r_id = query.r_id;
    let date = query.date;
    const [data, setData] = useState([]);
    const [si_data, setSiData] = useState([]);
    // const [isTitle, setTitle] = useState('신청내역 확인');
    const [r_status, setStatus] = useState('');


    let obj = { r_id: r_id }
    useEffect(() => {
        const fetchData = async () => {
            instance.post('/reserve/r_id', obj).then(function (res) {
                setData(res.data[0]);
                setStatus(res.data[0].r_status);
            });

        };
        fetchData();
    }, []);

    const goPage = () => {
        history.push('/');
    }
    const goBojung = () =>{
        history.push('/bojungok?r_id='+r_id);
    }

    const junbi = () => {
        alert('서비스 준비 중 입니다');
    }

    return (
        <>
            <Container className="mb-5">
                <TopTitle title="작업 내역" style={{marginBottom: '50px'}}/>
                <div className="c_pad mt-5">
                    {/* <TopTitle title={isTitle} /> */}
                    {/* <SigongId si_id={si_id} setSiData={setSiData} si_data={si_data}/> */}

                    <ServiceId
                        data={data}
                        u_type={u_type}
                        date={date}
                        location={location}
                    />
                    <div className="row mb-2 p-0">
                        <div className="col-6 pl-0 text-center">
                            <span className="btn btn-outline-secondary r_btnsize" onClick={goPage}>목록으로</span>
                        </div>
                        <div className="col-6 pr-0 text-center">
                            <span className="btn btn-primary r_btnsize" onClick={goBojung}>보증서 확인</span>
                        </div>
                    </div>
                </div>

            </Container>

        </>

    )
}

export default WorkDetailPage